import React, { useState, useEffect } from "react"
import { 
  Alert, 
  Breadcrumb, 
  notification, 
  Spin, 
  Tabs, 
  Tag, 
  Card, 
  Flex, 
  Typography, 
  Divider,
  Space,
  Empty
} from "antd"
import {
  HomeOutlined,
  UnorderedListOutlined,
  FolderOpenOutlined,
  FileOutlined,
  FileTextOutlined,
  CheckSquareOutlined,
  CommentOutlined,
  EditOutlined,
  UserOutlined,
  BuildOutlined,
  NumberOutlined,
  DashboardOutlined,
  LoadingOutlined
} from "@ant-design/icons"
import { ProjectFiles } from "./ProjectFiles"
import { ProjectRequired } from "./ProjectRequired"
import {
  addFileGasProject,
  addFileGasProjectSingle,
  getGasProjectFiles,
  getGppByGpId,
  getProjectProcessEng,
  getUserBalance,
  resetGasProjectFlag,
  submitDesignStage,
  updateGasProjectDetailsNew,
  updateGasProjectEngNew,
  updateProcessDefectStageNew,
  updateProcessExpertStageNew,
  updateProcessMapStageNew,
  upsertGasProject,
} from "store/actions"
import { connect } from "react-redux"
import { withTranslation } from "react-i18next"
import { useParams } from "react-router-dom/cjs/react-router-dom"
import ProjectUpdate from "./ProjectUpdate"
import { ProjectProcess } from "./ProjectProcess"
import { SubmitDesign } from "./SubmitDesign"
import { SubmitSupervision } from "./SubmitSupervision"

const { Title, Text } = Typography

const GasProjectDashboardEng = props => {
  const {
    projectProcessEng,
    matches_sm,
    loading,
    onGetProjectProcessEng,
    onResetGasProjectFlag,
    triggerReload,
  } = props
  const [api, contextHolder] = notification.useNotification()
  const [errorMessage, setErrorMessage] = useState(null)
  const { id } = useParams()
  
  const openNotification = (type, placement, message) => {
    api[type]({
      message,
      placement,
    })
  }
  
  const firstLoad = async () => {
    let searchQuery = {
      id,
      page: 1,
      pageSize: 1,
      fileNumber: 0,
      solarDateDeliverEngineer: "",
      idSection: 0,
      landlordName: "",
      executorName: "",
    }
    onGetProjectProcessEng(searchQuery)
  }
  
  useEffect(() => {
    if (props.success) openNotification("success", "top", props.success)
    if (props.error) openNotification("error", "top", props.error)
    if (errorMessage) openNotification("warning", "top", props.error)
    onResetGasProjectFlag()
  }, [errorMessage, props.success, props.error])

  const [activeKey, setActiveKey] = useState("1")

  // Get project data
  const projectData = projectProcessEng[0]

  // Helper function to get owner name
  const getOwnerName = () => {
    if (!projectData) return ""
    return projectData.gasProject?.ownershipTypeEnum === 1
      ? projectData.landLordName
      : projectData.companyName
  }

  // Helper function to get floor display
  const getFloorDisplay = () => {
    if (!projectData) return ""
    if (projectData.floorNumber === 0) {
      return projectData.unitNumber > 1 ? "چند واحدی" : "همکف"
    }
    return projectData.floorNumber
  }

  // Tabs configuration with icons
  const tabItems = (projectProcess) => [
    {
      key: "1",
      visible: true,
      label: (
        <Flex align="center" gap={6}>
          <FolderOpenOutlined />
          <span>پرونده</span>
        </Flex>
      ),
      children: (
        <ProjectUpdate
          rowData={projectProcess}
          matches_sm={matches_sm}
          openNotification={openNotification}
          mainProps={props}
        />
      ),
    },
    {
      key: "2",
      visible: true,
      label: (
        <Flex align="center" gap={6}>
          <FileOutlined />
          <span>فایلها</span>
        </Flex>
      ),
      children: (
        <ProjectFiles
          rowData={projectProcess}
          matches_sm={matches_sm}
          openNotification={openNotification}
          mainProps={props}
        />
      ),
    },
    {
      key: "3",
      visible: true,
      label: (
        <Flex align="center" gap={6}>
          <CheckSquareOutlined />
          <span>الزامات</span>
        </Flex>
      ),
      children: (
        <ProjectRequired
          rowData={projectProcess}
          matches_sm={matches_sm}
          openNotification={openNotification}
          mainProps={props}
        />
      ),
    },
    {
      key: "4",
      label: (
        <Flex align="center" gap={6}>
          <CommentOutlined />
          <span>نظرات کارشناسی</span>
        </Flex>
      ),
      visible: true,
      children: (
        <ProjectProcess
          rowData={projectProcess}
          matches_sm={matches_sm}
          openNotification={openNotification}
          mainProps={props}
        />
      ),
    },
    {
      key: "5",
      visible: true,
      label: (
        <Flex align="center" gap={6}>
          <EditOutlined />
          <span>
            {(() => {
              switch (projectProcess?.projectLevel) {
                case 3:
                case 5:
                  return "اعلام نظر مرحله نقشه"
                case 4:
                  return "اعلام نظر طراحی"
                default:
                  return "اعلام نظر"
              }
            })()}
          </span>
        </Flex>
      ),
      children: (() => {
        if (projectProcess?.inspectionStatus !== 0)
          return (
            <Card>
              <Alert
                message="قبلا اعلام نظر انجام شده است"
                type="info"
                showIcon
              />
            </Card>
          )
        switch (projectProcess?.projectLevel) {
          case 3:
          case 5:
            return (
              <SubmitSupervision
                rowData={projectProcess}
                reload={triggerReload}
                matches_sm={matches_sm}
                openNotification={openNotification}
                mainProps={props}
              />
            )
          case 4:
            return (
              <SubmitDesign
                rowData={projectProcess}
                reload={triggerReload}
                matches_sm={matches_sm}
                openNotification={openNotification}
                mainProps={props}
              />
            )
          default:
            return (
              <Card>
                <Alert
                  message="اعلام نظر غیر فعال می باشد"
                  type="warning"
                  showIcon
                />
              </Card>
            )
        }
      })(),
    },
  ].filter(item => item.visible)

  useEffect(() => {
    console.log("id, triggerReload", id, triggerReload)
    firstLoad()
  }, [id, triggerReload])

  const handleTabChange = key => {
    setActiveKey(key)
  }

  // Info item component for header
  const InfoItem = ({ icon, label, value, color }) => (
    <Flex align="center" gap={6}>
      {icon}
      <Text style={{ color: "rgba(255,255,255,0.8)", fontSize: 12 }}>{label}:</Text>
      <Tag 
        color={color || "default"} 
        style={{ 
          margin: 0, 
          fontWeight: 500,
          borderRadius: 4
        }}
      >
        {value}
      </Tag>
    </Flex>
  )

  return (
    <div className="page-content">
      {contextHolder}
      
      {/* Modern Header Card */}
      <Card
        style={{
          marginBottom: 16,
          borderRadius: 12,
          overflow: "hidden",
          border: "none",
          boxShadow: "0 2px 8px rgba(0,0,0,0.08)"
        }}
        bodyStyle={{ padding: 0 }}
      >
        {/* Gradient Header */}
        <div
          style={{
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            padding: "16px 24px",
          }}
        >
          {/* Breadcrumb */}
          <Breadcrumb
            separator="/"
            style={{ marginBottom: 12 }}
            items={[
              {
                title: (
                  <a href="/dashboard" style={{ color: "rgba(255,255,255,0.8)" }}>
                    <HomeOutlined style={{ marginLeft: 4 }} />
                    داشبورد
                  </a>
                ),
              },
              {
                title: (
                  <a href="/projects/GasProjectProcessEng" style={{ color: "rgba(255,255,255,0.8)" }}>
                    <UnorderedListOutlined style={{ marginLeft: 4 }} />
                    لیست تخصیص
                  </a>
                ),
              },
              {
                title: (
                  <span style={{ color: "#fff", fontWeight: 500 }}>
                    <FileTextOutlined style={{ marginLeft: 4 }} />
                    جزئیات پرونده
                  </span>
                ),
              },
            ]}
          />

          {/* Title and File Number */}
          <Flex justify="space-between" align="center" wrap="wrap" gap={12}>
            <Flex align="center" gap={12}>
              <div
                style={{
                  width: 48,
                  height: 48,
                  borderRadius: 10,
                  background: "rgba(255,255,255,0.2)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <FolderOpenOutlined style={{ fontSize: 24, color: "#fff" }} />
              </div>
              <div>
                <Title level={4} style={{ color: "#fff", margin: 0 }}>
                  {projectData ? `پرونده شماره ${projectData.fileNumber}` : "در حال بارگذاری..."}
                </Title>
                <Text style={{ color: "rgba(255,255,255,0.7)", fontSize: 13 }}>
                  مدیریت و پیگیری پرونده گاز
                </Text>
              </div>
            </Flex>
            
            {projectData && (
              <Tag
                color={projectData.inspectionStatus === 0 ? "processing" : "success"}
                style={{
                  padding: "4px 12px",
                  borderRadius: 20,
                  fontSize: 13,
                  fontWeight: 500
                }}
              >
                {projectData.inspectionStatus === 0 ? "در انتظار بررسی" : "بررسی شده"}
              </Tag>
            )}
          </Flex>
        </div>

        {/* Project Info Bar */}
        {projectData && (
          <div
            style={{
              background: "linear-gradient(135deg, #5a67d8 0%, #6b46c1 100%)",
              padding: "12px 24px",
              borderTop: "1px solid rgba(255,255,255,0.1)"
            }}
          >
            <Flex wrap="wrap" gap={16} justify="flex-start">
              <InfoItem
                icon={<UserOutlined style={{ color: "rgba(255,255,255,0.8)" }} />}
                label="مالک"
                value={getOwnerName()}
                color="blue"
              />
              <InfoItem
                icon={<BuildOutlined style={{ color: "rgba(255,255,255,0.8)" }} />}
                label="تعداد واحد"
                value={projectData.unitNumber}
                color="green"
              />
              <InfoItem
                icon={<NumberOutlined style={{ color: "rgba(255,255,255,0.8)" }} />}
                label="طبقه"
                value={getFloorDisplay()}
                color="orange"
              />
              <InfoItem
                icon={<DashboardOutlined style={{ color: "rgba(255,255,255,0.8)" }} />}
                label="کنتور"
                value={projectData.inspectionParameterTypeName}
                color="purple"
              />
            </Flex>
          </div>
        )}
      </Card>

      {/* Tabs Card */}
      <Card
        style={{
          borderRadius: 12,
          border: "none",
          boxShadow: "0 2px 8px rgba(0,0,0,0.08)"
        }}
        bodyStyle={{ padding: "8px 16px 16px" }}
      >
        <Spin
          spinning={!projectData && loading}
          indicator={<LoadingOutlined style={{ fontSize: 32 }} spin />}
          tip="درحال بارگذاری..."
          size="large"
        >
          <div style={{ minHeight: 300 }}>
            {!loading && !projectData ? (
              <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description={
                  <Text type="secondary">اطلاعات بارگذاری نشد</Text>
                }
                style={{ padding: "60px 0" }}
              />
            ) : (
              projectData && (
                <Tabs
                  activeKey={activeKey}
                  onChange={handleTabChange}
                  items={tabItems(projectData)}
                  type="card"
                  style={{ marginTop: 8 }}
                  tabBarStyle={{
                    marginBottom: 16,
                  }}
                />
              )
            )}
          </div>
        </Spin>
      </Card>
    </div>
  )
}

const mapStateToProps = ({
  GasProjects,
  USERs,
  GasProjectProcesses,
  Engineers,
}) => ({
  projectProcessEng: GasProjectProcesses.projectProcessEng,
  lstGasProjectFiles: GasProjects.lstGasProjectFiles,
  lstGpp: GasProjectProcesses.lstGpp,
  currentIdGasProject: GasProjects.currentIdGasProject,
  error: GasProjectProcesses.error || GasProjects.error,
  success: GasProjectProcesses.success || GasProjects.success,
  loading: GasProjectProcesses.loading || GasProjects.loading,
  loadingGasProject: GasProjects.loading,
  userBalance: USERs.userBalance,
  triggerReload: GasProjects.triggerReload,
})

const mapDispatchToProps = dispatch => ({
  onGetProjectProcessEng: searchValue =>
    dispatch(getProjectProcessEng(searchValue)),
  onResetGasProjectFlag: () => dispatch(resetGasProjectFlag()),
  onGetUserBalance: () => dispatch(getUserBalance()),
  onAddFileGasProject: attachData => dispatch(addFileGasProject(attachData)),
  onAddFileGasProjectSingle: attachData =>
    dispatch(addFileGasProjectSingle(attachData)),
  onUpdateProcessExpertStageNew: process =>
    dispatch(updateProcessExpertStageNew(process)),
  onUpdateProcessMapStageNew: process =>
    dispatch(updateProcessMapStageNew(process)),
  onUpdateProcessDefectStageNew: process =>
    dispatch(updateProcessDefectStageNew(process)),

  onGetProjectFiles: gasProjectId => dispatch(getGasProjectFiles(gasProjectId)),
  onUpdateGasProjectDetailsNew: process =>
    dispatch(updateGasProjectDetailsNew(process)),
  onUpdateGasProjectEngNew: gasProject =>
    dispatch(updateGasProjectEngNew(gasProject)),
  onGetGppByGpId: gasProjectId => dispatch(getGppByGpId(gasProjectId)),
  onSubmitDesignStage: process => dispatch(submitDesignStage(process)),
  onSubmitFirstSupervisionStage: process =>
    dispatch(submitFirstSupervisionStage(process)),
  onUpdateGasProjectCheckList: process =>
    dispatch(updateGasProjectCheckList(process)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(GasProjectDashboardEng))
